import { useFeatureFlag } from '~/composables/useFeatureFlag'

export default defineNuxtRouteMiddleware(async (to) => {
  if (!useFeatureFlag('ssoLogin')) {
    return
  }

  const userStore = useUserStore()
  const { readAccessToken } = useYscTokens()

  if (!userStore.isLoggedIn) {
    if (readAccessToken()) {
      await userStore.fetchUser()
      return
    }

    return navigateTo({
      name: 'index',
      query: { 'next': to.fullPath, 'sso-modal': true },
    }, { replace: true })
  }
  return
})
